/**
 * 환경 설정 관리 모듈
 */

// 클라이언트 ID 확인
const queryParam = new URLSearchParams(window.location.search);
const clientId = queryParam.get("client_id");

// 환경 설정 타입 정의
interface EnvConfig {
  basicHeader: string;
  baseUrl: string | undefined;
  authUrl: string | undefined;
}

// 클라이언트 타입에 따른 환경 변수 매핑
const envConfigs: Record<string, EnvConfig> = {
  grafana: {
    basicHeader: window.btoa(
      `${process.env.REACT_APP_OAUTH_LOGIN_CLIENT_ID}:${process.env.REACT_APP_OAUTH_LOGIN_CLIENT_SECRET}`
    ),
    baseUrl: process.env.REACT_APP_BASE_URL,
    authUrl: process.env.REACT_APP_AUTH_URL,
  },
  default: {
    basicHeader: window.btoa(
      `${process.env.REACT_APP_OAUTH_LOGIN_CLIENT_ID}:${process.env.REACT_APP_OAUTH_LOGIN_CLIENT_SECRET}`
    ),
    baseUrl: process.env.REACT_APP_BASE_URL,
    authUrl: process.env.REACT_APP_AUTH_URL,
  },
};

// 클라이언트 ID에 따른 환경 설정 내보내기
export const ENV: EnvConfig =
  envConfigs[clientId as keyof typeof envConfigs] || envConfigs.default;
